import React from 'react';
import Icon from '../../../components/AppIcon';

const FitnessGoalSelector = ({ goals, selectedGoals, onToggle }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
      {goals?.map((goal) => {
        const isSelected = selectedGoals?.includes(goal?.id);
        return (
          <button
            key={goal?.id}
            type="button"
            onClick={() => onToggle(goal?.id)}
            className={`
              flex items-center gap-4 p-4 rounded-lg border-2 text-left transition-smooth hover-lift press-scale
              ${isSelected
                ? 'bg-accent/10 border-accent' :'bg-card border-border hover:border-accent/50'
              }
            `}
          >
            <div className={`
              flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0
              ${isSelected ? 'bg-accent text-accent-foreground' : 'bg-muted text-muted-foreground'}
            `}>
              <Icon name={goal?.icon} size={24} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-heading font-semibold text-foreground mb-1">
                {goal?.label}
              </h4>
              <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                {goal?.description}
              </p>
            </div>
            {isSelected && (
              <Icon name="Check" size={20} color="var(--color-accent)" strokeWidth={2.5} />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default FitnessGoalSelector;